import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './styles.css'

toast.configure();

export const SuccessToast = (data) => {
  return (
    <>
      {Array.isArray(data)
        ? data.map((item, i) => {
            const message = typeof item === 'string' ? item : 'Success';
            return toast.success(message.toUpperCase(), {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
              className: 'toast_success_override',
            });
          })
        : toast.success(
            (typeof data === 'string' ? data : 'Success').toUpperCase(),
            {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
              className: 'toast_success_override',
            }
          )}
    </>
  );
};


export const ErrorToast = (data) => {
  return (
    <>
      {Array.isArray(data)
        ? data.map((item, i) => {
            const message = typeof item === 'string' ? item : 'An error occurred';
            return toast.error(message.toUpperCase(), {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
              className: 'toast_error_override',
            });
          })
        : toast.error(
            (typeof data === 'string' ? data : 'An error occurred').toUpperCase(),
            {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
              className: 'toast_error_override',
            }
          )}
    </>
  );
};
